import { Stack, Skeleton, Group } from "@mantine/core";

export function LoadingPage() {
  return (
    <Stack gap="lg">
      <Skeleton height={12} width={200} />
      <Group justify="space-between">
        <Skeleton height={32} width={250} />
        <Skeleton height={36} width={120} radius="md" />
      </Group>
      <Skeleton height={300} radius="md" />
    </Stack>
  );
}
